import { type Control, Controller } from "react-hook-form";

import { Select2 } from "@/ui2/molecules/Select";
import { useCosignSupervisors } from "@/features/cosign/api/queries/useCosignSupervisors";

import { CoSignFormValues } from "../schema";

import { AssignedSupervisorSelectSkeleton } from "./AssignedSupervisorSelectSkeleton";

type AssignedSupervisorsSelectProps = {
  control: Control<CoSignFormValues>;
};

export function AssignedSupervisorsSelect({ control }: AssignedSupervisorsSelectProps) {
  const { data: supervisors, isLoading } = useCosignSupervisors();

  if (isLoading) return <AssignedSupervisorSelectSkeleton />;

  return (
    <Controller
      control={control}
      name="supervisorId"
      render={({ field }) => (
        <Select2
          label="Assigned Supervisor"
          onChange={field.onChange}
          options={supervisors}
          placeholder="Assigned Supervisor"
          value={field.value || null}
        />
      )}
    />
  );
}
